import { IImageElement } from '@faire/web-api--source/indigofair/data/IImageElement';
import { ITextElement } from '@faire/web-api--source/indigofair/data/ITextElement';

export namespace IImageFanTile {
  export namespace IImageFanTileStyle {
    /**
     * Return an instance of IImageFanTileStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IImageFanTileStyle>
    ): IImageFanTileStyle =>
      ({
        animation_on_hover: [],
        ...(partial ?? {}),
      }) as IImageFanTileStyle;
  }

  export interface IImageFanTileStyle {
    animation_on_hover: Array<keyof typeof IImageFanTile.ImageFanTileAnimation>;
  }

  export enum ImageFanTileAnimation {
    IMAGE_FAN_TILE_ANIMATION_UNKNOWN = 'IMAGE_FAN_TILE_ANIMATION_UNKNOWN',
    HIGHLIGHT_BORDER = 'HIGHLIGHT_BORDER',
    FAN_OUT_IMAGES = 'FAN_OUT_IMAGES',
  }

  /**
   * Return an instance of IImageFanTile with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IImageFanTile>): IImageFanTile =>
    ({
      image_elements: [],
      ...(partial ?? {}),
    }) as IImageFanTile;
}

export interface IImageFanTile {
  primary_text: ITextElement | undefined;
  image_elements: Array<IImageElement>;
  image_fan_tile_style: IImageFanTile.IImageFanTileStyle | undefined;
}
